import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  resetBays({ commit }, firm) {
    commit(types.RESET_BAYS, firm)
  },
  initBay({ commit }, firm) {
    commit(types.INIT_BAY, firm)
  },
  setBay({ commit }, data) {
    commit(types.SET_BAY, data)
  },
  updateBay({ commit }, data) {
    commit(types.UPDATE_BAY, data)
  },
  updateSlot({ commit }, data) {
    commit(types.UPDATE_SLOT, data)
  },
  setSlot({ commit }, data) {
    commit(types.SET_SLOT, data)
  },
  async getBays({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getBays', () =>
      http.get(
        `bay/bays?firm=${data.firm}&technician=${data.technician}&showInactive=${data.showInactive}`
      )
    )
    commit(types.SET_BAYS, r.data)
    return r.data
  },
  async getBay({ commit, dispatch }, bay) {
    const r = await startLoading(dispatch, 'getBay', () => http.get(`bay/bay?bay=${bay}`))
    commit(types.SET_BAY, r.data)
    return r.data
  },
  async saveBay({ state, dispatch }) {
    const r = await startLoading(dispatch, 'saveBay', () => http.post('bay/saveBay', state.bay))
    return r.data
  },
  async deleteBay({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteBay', () => http.post('bay/deleteBay', data))
    return r.data
  },
  async getSlots({ commit, dispatch }, firm) {
    let tz = new Date().getTimezoneOffset()
    const r = await startLoading(dispatch, 'getSlots', () =>
      http.get(`bay/slots?firm=${firm}&tz=${tz}`)
    )
    commit(types.SET_SLOTS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bays/actions.js